import { render, staticRenderFns } from "./CollectionCreate.vue?vue&type=template&id=aaca7822&"
import script from "./CollectionCreate.vue?vue&type=script&lang=js&"
export * from "./CollectionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports